<script>
    import { FETCH_PRODUCTS } from "../../store/actions.type";
    import { MultiSelect } from 'vue-search-select'

    export default {
        name: "CustomMultiSelect",
        //extends: MultiSelect,
        mixins: [MultiSelect],
        methods: {
            deleteTextOrLastItem () {
                 // never delete items when using backspace
                 return undefined;
            },
            selectItem(option) {
                const tempSelectedOptions = this.selectedOptions.concat(option);
                const selectedOptions = tempSelectedOptions.filter((el, idx) => {
                    return tempSelectedOptions.indexOf(el) === idx
                });
                this.nextItem();
                this.$emit('select', selectedOptions, option, 'insert');
            },
            initMultiSelect() {
                const multiSelect = document.querySelector('.document-picker__multi-select');

                let query = '';

                multiSelect.addEventListener('keyup', (e) => {
                    if (e.keyCode !== 13) return;
                    this.$store.dispatch('myAdmin/' + FETCH_PRODUCTS, e.target.value);
                })
            }
        },
        mounted() {
            this.initMultiSelect();

        },
    }
</script>